import React from "react";
import { TextField } from "@material-ui/core";
import { post } from "../../lib/api";

async function execRename(props, setLogs) {
    let errorMsg = "";
    if (!props.psw) errorMsg += "Invalid Password.\n";
    if (!props.domain) errorMsg += "Invalid Current Domain or Subdomain.\n";
    if (!props.newDomain) errorMsg += "Invalid New Domain or Subdomain.\n";
    if (errorMsg) {
        alert(errorMsg);
        return false;
    }
    try {
        const res = await post("server/hetzner/renamedomain", props);
        setLogs(res.logs);
    }
    catch (e) {
        alert(e);
        return false;
    }

    return true;
}

export default function renameDomain(props, setProp, setLogs) {
    const title = "Rename Domain"
    const wizardData = [
        { title: "Add New DNS Records", descr: "Set the DNS records for the new domain", button: "GO TO DNS CONSOLE", link: "https://dns.hetzner.com/", onClick: () => true },
        {
            title: "Server Setup", descr: (
                <>
                    <TextField value={props.domain || ""} onChange={(e) => setProp("domain", e.target.value)} label="Current Domain or Subdomain" fullWidth />
                    <TextField value={props.newDomain || ""} onChange={(e) => setProp("newDomain", e.target.value)} label="New Domain or Subdomain" fullWidth />
                </>
            ), button: "EXECUTE", onClick: () => execRename(props, setLogs)
        },
        { title: "Delete Previous DNS Records", descr: "Delete the DNS records of the previous domain", button: "GO TO DNS CONSOLE", link: "https://dns.hetzner.com/", onClick: () => true },
        { title: "Go To OneZero Admin", descr: "Open OneZero Admin Console", button: "OPEN ", link: `https://${props.newDomain}/ozadmin`, onClick: () => false },
    ]

    return { title, wizardData };
}
